import React from 'react';
import { useSubscription } from '@apollo/client';
import { useAppContext, useUserContext } from '../../utils';

export const withSubscription = function (WrappedComponent) {
	const ReturnedComponent = function ({
		subscription,
		...otherProps
	}) {
		const { disableSubscriptions } = useAppContext();
		const { userSettings } = useUserContext();

		// This seems to invoke the subscription and update the cache
		// successfully upon mutation of existing list items
		// (but not upon the creation of new items). This seems desireable
		// for now, since adding new items gets extremely tricky with
		// different variables in the list view, as well as cached list queries
		// with different variable parameters.

		// Somehow, we don't even need to do anything with the data. Apollo just handles
		// it for us ;-)

		// This seems to open the websocket connection and leave it open even
		// when navigating to a new page. This is desireable and we will continue
		// to do this unless there are performance issues.

		// Allow app-level opt-out (e.g. web app) in addition to user performance mode.
		const isSkipped = Boolean(disableSubscriptions || userSettings?.performanceMode);

		const { error } = useSubscription(subscription, {
			variables: {
				input: {},
			},
			skip: isSkipped,
		});

		if (error) {
			console.log('There was a subscription error:', error);
		}

		return (
			<WrappedComponent {...otherProps} />
		);
	};

	return ReturnedComponent;
};



